import React from 'react';

export default function SimpleTestPage() {
  return (
    <div style={{ padding: '40px' }}>
      <h1>Simple SEO Test Page</h1>
      <p>If you can see this, the route is working!</p>
    </div>
  );
}